import React, { useContext, useEffect, useState } from 'react';
import TableProviderSurveys from "root/Tables/TableProviderSurveys";
import {getDataFromResponse} from "root/DataFunctions/BaseDataFns";
import {getProviderSurveys} from "root/DataFunctions/ProviderFns";
import GlobalContext from "root/Contexts/GlobalContext";

const HistoryContainer = (props) =>
{
    const [data, setData] = useState({loading: true, data: []});

    const sessionContext = useContext( GlobalContext ) ;

    const survey_type = sessionContext.getCurrentSurveyType() ;

    useEffect(() => {
        getData();
    }, []);

    const getData = () =>
    {
        getProviderSurveys( props.provider_id, (response) =>
        {
            const returnData = getDataFromResponse(response) ;

            setData({loading: false, data: returnData})
        })
    }

    return (
             <div className='container-for-tabs'>
                <TableProviderSurveys data={data} survey_type={survey_type}/>
            </div>

    )
}

export default HistoryContainer;
